import { useId } from "react";

const CSS = `
@keyframes vwOrbit{to{transform:rotate(360deg)}}
.vw-orbit{transform-box:view-box;transform-origin:50px 50px;animation:vwOrbit 24s linear infinite}
@media (prefers-reduced-motion:reduce){.vw-orbit{animation:none}}
`;
// Giro sull'orbita con ondulazione e poi discesa a spirale ondulata verso il centro (sistema non ruotato)
const PATH = (() => {
  const W = (t) => 3.5 * Math.sin(t * 7);
  const pts = [];
  for (let i = 0; i <= 50; i++) {
    const f = i / 50, r = f, t = -Math.PI * 1.5 * (1 - f);
    pts.push([50 + 48 * r * Math.cos(t), 50 + 14 * r * Math.sin(t) + r * W(t)]);
  }
  for (let i = 1; i <= 160; i++) {
    const t = (i / 160) * 2 * Math.PI;
    pts.push([50 + 48 * Math.cos(t), 50 + 14 * Math.sin(t) + W(t)]);
  }
  for (let i = 1; i <= 50; i++) {
    const f = i / 50, r = 1 - f, t = f * Math.PI * 1.5;
    pts.push([50 + 48 * r * Math.cos(t), 50 + 14 * r * Math.sin(t) + r * W(t)]);
  }
  return "M" + pts.map(([x, y]) => `${x.toFixed(2)},${y.toFixed(2)}`).join(" L");
})();
const SPARKS = Array.from({ length: 8 }, (_, i) => {
  const a = (i / 8) * 2 * Math.PI + 0.3;
  return { dx: (Math.cos(a) * 46).toFixed(1), dy: (Math.sin(a) * 34 + 18).toFixed(1), d: (i % 3) * 0.12 };
});

// Logo Vesta World: globo con orbita; il focolare parte dal centro, percorre l'orbita ondeggiando, torna, arriva al centro, pulsa con scintille, attende 4s e ripete
export function VestaWorldLogo({ className = "h-12 w-12", color = "#C17F59", bg = "#0a0a0a", animated = true }) {
  const id = useId().replace(/[^a-zA-Z0-9]/g, "");
  const orbit = (stroke, w) => <ellipse cx="50" cy="50" rx="48" ry="14" transform="rotate(-24 50 50)" stroke={stroke} strokeWidth={w} />;
  const m = `m${id}`, p = `p${id}`;
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" overflow="visible" data-testid="vesta-world-logo" aria-label="Vesta World">
      <style>{CSS}</style>
      <defs>
        <clipPath id={`front-${id}`}><rect x="-60" y="0" width="120" height="60" transform="rotate(-24 50 50) translate(50 50)" /></clipPath>
        <radialGradient id={`sun-${id}`} cx=".5" cy=".55" r=".5"><stop offset="0" stopColor="#FFECD6" stopOpacity=".85" /><stop offset=".1" stopColor="#FFECD6" stopOpacity=".85" /><stop offset=".23" stopColor="#E8B48F" stopOpacity=".7" /><stop offset=".45" stopColor="#C17F59" stopOpacity=".5" /><stop offset=".74" stopColor="#A05A37" stopOpacity=".15" /><stop offset="1" stopColor="#A05A37" stopOpacity="0" /></radialGradient>
        <filter id={`glow-${id}`} x="-1" y="-1" width="3" height="3"><feGaussianBlur stdDeviation=".8" /></filter>
        <filter id={`spk-${id}`} x="-2" y="-2" width="5" height="5"><feGaussianBlur stdDeviation=".8" result="b" /><feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge></filter>
      </defs>
      <circle cx="50" cy="50" r="36" stroke={color} strokeWidth="3" />
      <g className={animated ? "vw-orbit" : ""} data-testid="vesta-world-logo-orbit-back">{orbit(color, 3)}</g>
      <g className={animated ? "vw-orbit" : ""}>
        <g clipPath={`url(#front-${id})`}>{orbit(bg, 7)}{orbit(color, 3)}</g>
        <g transform={animated ? "rotate(-24 50 50)" : "translate(50 50)"} data-testid="vesta-world-logo-sun">
          <g>
            {animated && <animateMotion id={m} dur="13s" begin={`0s;${p}.end+4s`} fill="freeze" path={PATH} calcMode="spline" keyPoints="0;1" keyTimes="0;1" keySplines=".42 0 .58 1" />}
            <circle r="73" fill={`url(#sun-${id})`} filter={`url(#glow-${id})`}>
              {animated && <animate id={p} attributeName="r" values="73;90;73;85;73" dur="3.4s" begin={`${m}.end`} calcMode="spline" keyTimes="0;.25;.5;.75;1" keySplines=".4 0 .6 1;.4 0 .6 1;.4 0 .6 1;.4 0 .6 1" />}
            </circle>
            {animated && SPARKS.map((k, i) => (
              <circle key={i} r="3" fill="#F3C58F" opacity="0" filter={`url(#spk-${id})`} data-testid="vesta-world-logo-spark">
                <animate attributeName="opacity" values="0;1;1;0" keyTimes="0;.05;.5;1" dur="2.2s" begin={`${m}.end+${k.d}s`} />
                <animateTransform attributeName="transform" type="translate" values={`0 0;${k.dx} ${k.dy}`} dur="2.2s" begin={`${m}.end+${k.d}s`} calcMode="spline" keyTimes="0;1" keySplines=".2 .6 .4 1" />
                <animate attributeName="r" values="3;.8" dur="2.2s" begin={`${m}.end+${k.d}s`} />
              </circle>
            ))}
          </g>
        </g>
      </g>
    </svg>
  );
}
